import { FullLoader } from 'components/layouts/Loader';
import Login from 'pages/auth/Login';
import { Navigate } from 'react-router-dom';
import useUserStore from 'state/userStore';

export const ProtectedRoute = ({ children, type }) => {
  const token = window.localStorage.getItem('token');
  const { user } = useUserStore();

  //   user is authenticated
  if (token) {
    if (user) {
      if (user.type !== type) return <Navigate to="/" />;
      return children;
    } else {
      return <FullLoader />;
    }
  }
  return <Login />;
};
